<mat-card class="card__logout">
    <mat-card-title>You have been logged out.</mat-card-title>
    <mat-card-content>
        <p>Please <a href="/login">log in</a> again to continue using the application.</p>
    </mat-card-content>
  </mat-card>